import angular from 'angular';

export default class MapManager {
    constructor(NgMap, $window, $q, $timeout) {
        this.ngMap = NgMap;
        this.$window = $window;
        this.$q = $q;
        this.$timeout = $timeout;

        this.map = null;
        this.mapPromise = null;
        this.markerClusterer = null;
        this.resizingPromise = null;

        this.getMapInstance().then(() => {
            this.setupResize();
        });
    }

    setupResize() {
        this.$window.addEventListener('resize', () => {
            if (this.resizingPromise) {
                return;
            }

            this.resizingPromise = this.$timeout(() => {
                this.getMapInstance()
                    .then((map) => {
                        const center = map.getCenter();
                        const maps = this.$window.google?.maps;

                        maps?.event?.trigger(map, 'resize');

                        map.setCenter(center);
                    })
                    .finally(() => {
                        this.resizingPromise = null;
                    });
            }, 2);
        });
    }

    updateCluster() {
        return this.getMapInstance().then(() => {
            this.doUpdateCluster();
        });
    }

    doUpdateCluster() {
        if (this.markerClusterer !== null) {
            this.markerClusterer.clearMarkers();
        }

        var locationMarkers = [];
        angular.forEach(this.map.markers, (marker) => {
            locationMarkers.push(marker);
        });

        this.markerClusterer = new MarkerClusterer(this.map, locationMarkers, {
            // imagePath: webpack_env.publicPath + 'm',
            imagePath: 'https://github.com/googlemaps/js-marker-clusterer/raw/gh-pages/images/m',
            maxZoom: 17,
            gridSize: 50,
        });
    }

    showInfoWindow(markerIdentifier) {
        this.getMapInstance().then((map) => {
            map.showInfoWindow('default', markerIdentifier);
        });
    }

    fitBounds(bounds) {
        if (!bounds) {
            return this.$q.when();
        }

        return this.getMapInstance().then((map) => {
            const maps = this.$window.google?.maps;

            if (!maps?.LatLng || !maps?.LatLngBounds) {
                return map;
            }

            const south = Number(bounds.south);
            const west = Number(bounds.west);
            const north = Number(bounds.north);
            const east = Number(bounds.east);

            if ([south, west, north, east].some(Number.isNaN)) {
                return map;
            }

            const latLngBounds = new maps.LatLngBounds(
                new maps.LatLng(south, west),
                new maps.LatLng(north, east)
            );

            map.fitBounds(latLngBounds);

            return map;
        });
    }

    setCenter(center, zoom) {
        if (!center) {
            return this.$q.when();
        }

        return this.getMapInstance().then((map) => {
            const { google } = this.$window;

            if (!google?.maps?.LatLng) {
                return map;
            }

            const lat = Number(center.lat);
            const lng = Number(center.lng);

            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                map.setCenter(new google.maps.LatLng(lat, lng));
            }

            if (typeof zoom === 'number') {
                map.setZoom(zoom);
            }

            return map;
        });
    }

    getMapInstance() {
        if (this.map) {
            return this.$q.when(this.map);
        }

        if (this.mapPromise) {
            return this.mapPromise;
        }

        this.mapPromise = this.ngMap
            .getMap()
            .then((map) => {
                this.map = map;

                return map;
            })
            .finally(() => {
                this.mapPromise = null;
            });

        return this.mapPromise;
    }
}

MapManager.$inject = ['NgMap', '$window', '$q', '$timeout'];
